import Index from './Index';
import AgentReports from './AgentReports';
import LabelReports from './LabelReports';
import InboxReports from './InboxReports';
import TeamReports from './TeamReports';
import CsatResponses from './CsatResponses';
import NewCsatResponses from './NewCsatResponses.vue';
import LiveReports from './LiveReports';
import SettingsContent from '../Wrapper';
import { frontendURL } from '../../../../helper/URLHelper';
import {requireAuth} from "../../dashboard.routes";
import {FEATURE_FLAGS} from "../../../../featureFlags";

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'overview',
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: Index,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
    // {
    //   path: frontendURL('accounts/:accountId/reports'),
    //   component: SettingsContent,
    //   props: {
    //     headerTitle: 'CSAT_REPORTS.HEADER',
    //     icon: 'emoji',
    //     keepAlive: false,
    //   },
    //   children: [
    //     {
    //       path: 'csat',
    //       name: 'csat_reports',
    //       roles: ['administrator'],
    //       component: CsatResponses,
    //       beforeEnter: requireAuth,
    //       meta: {
    //         permission: FEATURE_FLAGS.REPORTS
    //       }
    //     },
    //   ],
    // },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_REPORTS.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          path: 'csat',
          name: 'csat_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: NewCsatResponses,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent',
          name: 'agent_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: AgentReports,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: LabelReports,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: InboxReports,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          roles: ['administrator', 'report_manage'],
          custom_role: 'report_manage',
          component: TeamReports,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator', 'report_manage'],
          }
        },
      ],
    },
  ],
};
